import React, { useEffect, useState } from "react"
import IntlProps from "../../../../state/helpers/IntlProps"
import { injectIntl } from "react-intl"
import { imageAndTextRowMessages } from "./messages"
import InputTextAndImageRow from "./InputTextAndImageRow"
import { Cell, Content, ContentType, Value, VerticalAlignment } from "./types"

// Input default value: 4 images components
const defaultCell = {
    contentType: ContentType.IMAGE,
}

const buildDefaultCells = (nbColumns) => {
    return Array(nbColumns).fill(defaultCell)
}

const handleCellsLengthChange = (cells: Cell[], nbColumns: number) => {
    if (!cells) {
        return buildDefaultCells(nbColumns)
    } else if (nbColumns < cells.length + 1) {
        return cells.slice(0, nbColumns)
    } else {
        return [
            ...cells,
            ...Array(nbColumns - cells.length).fill(defaultCell)
        ]
    }
}

interface Props {
    value: Value
    onChange: (value: Value) => void
}

const TextAndImageRowContentInput: React.FC<Props & IntlProps> = ({
    value = {
        cells: [],
        verticalAlignment: VerticalAlignment.MIDDLE
    }, ...props
}) => {

    const [verticalAlignment, setVerticalAlignment] = useState<VerticalAlignment>(
        value.verticalAlignment || VerticalAlignment.MIDDLE
    )
    const [cells, setCells] = useState<Cell[]>(value.cells || buildDefaultCells(4))

    useEffect(() => {
        props.onChange({
            verticalAlignment,
            cells,
        })
    }, [cells, verticalAlignment])

    const onNbColumnsSelectChange = (event) => {
        const nbColumns = parseInt(event?.target.value)

        setCells((curr) => handleCellsLengthChange(curr, nbColumns))
    }

    const onVerticalAlignmentSelectChange = (event) => {
        setVerticalAlignment(event?.target.value)
    }

    const onContentChange = (index: number, contentType: ContentType, cellContent: Content) => {

        setCells((curr) => {
            const newCells = [...curr || []]

            newCells[index] = {
                contentType,
                cellContent,
            }

            return newCells
        })

    }

    return (
        <div>

            {/* number of columns  */}
            <div className="form-group row">
                <label className="col-2 col-form-label text-align-right" htmlFor="nbColumns">
                    {props.intl.formatMessage(imageAndTextRowMessages.numberOfColumnsLabel)}
                </label>
                <div className="col-10">
                    <select
                        name="nbColumns"
                        value={cells?.length}
                        onChange={onNbColumnsSelectChange}
                        id="nbColumns"
                        className="form-control"
                    >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                    </select>
                    <small className="form-text text-muted">
                        {props.intl.formatMessage(imageAndTextRowMessages.numberOfColumnsOnTheSameRow)}
                    </small>
                </div>
            </div>

            {/* vertical alignment */}
            <div className="form-group row">
                <label className="col-2 col-form-label text-align-right" htmlFor="verticalAlignment">
                    {props.intl.formatMessage(imageAndTextRowMessages.verticalAlignmentLabel)}
                </label>
                <div className="col-10">
                    <select
                        name="verticalAlignment"
                        value={verticalAlignment}
                        onChange={onVerticalAlignmentSelectChange}
                        id="verticalAlignment"
                        className="form-control"
                    >
                        <option
                            value="top">{props.intl.formatMessage(imageAndTextRowMessages.verticalAlignmentTop)}</option>
                        <option
                            value="middle">{props.intl.formatMessage(imageAndTextRowMessages.verticalAlignmentMiddle)}</option>
                        <option
                            value="bottom">{props.intl.formatMessage(imageAndTextRowMessages.verticalAlignmentBottom)}</option>
                    </select>
                    <small className="form-text text-muted">
                        {props.intl.formatMessage(imageAndTextRowMessages.verticalAlignmentOfTheColumns)}
                    </small>
                </div>
            </div>

            {/* display <InputTextAndImageRow /> component cells.length times */}
            {cells?.map((cell, i) => (
                <InputTextAndImageRow cellIndex={i} key={i} {...props} onChange={onContentChange} value={cell}/>
            ))}
        </div>
    )
}

export default injectIntl(TextAndImageRowContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/input.component.tsx